import { render, staticRenderFns } from "./GymRating-List.vue?vue&type=template&id=593f59f2&"
import script from "./GymRating-List.js?vue&type=script&lang=js&"
export * from "./GymRating-List.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports